import { render, staticRenderFns } from "./ModalPopup.vue?vue&type=template&id=ec9a734a&scoped=true"
import script from "./ModalPopup.vue?vue&type=script&lang=js"
export * from "./ModalPopup.vue?vue&type=script&lang=js"
import style0 from "./ModalPopup.vue?vue&type=style&index=0&id=ec9a734a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9a734a",
  null
  
)

export default component.exports